@if (isNewNotificationBannerEnable()) {
    @if (notificationsBanners$ | async; as notificationsBanners) {
        @if (notificationsBanners.length) {
            @if (isMobile() && this.context.isInBrowserMode()) {
                <div
                    class="notification-banner-overlay"
                    [class.hidden-animation]="hideWithAnimation()"
                    (click)="close()">
                    <ng-container *ngTemplateOutlet="callToActionCheckout"></ng-container>
                </div>
            } @else {
                <ng-container *ngTemplateOutlet="callToActionCheckout"></ng-container>
            }

            <ng-template #callToActionCheckout>
                <div
                    (click)="$event.stopPropagation()"
                    id="notification-banner-modal"
                    class="banner notification-banner-modal"
                    [class.hidden-animation]="hideWithAnimation()"
                    [class.show-animation]="showWithAnimation()"
                    data-nosnippet
                    role="dialog">
                    <div class="notification-banner-modal-header">
                        <span
                            id="notification-title"
                            i18n="@@hermes-global-translations.information"
                            role="heading"
                            aria-level="2"
                            class="heading-4"
                            >Information</span
                        >
                        <h-close-button
                            #closeButton
                            tabindex="0"
                            class="close-icon"
                            (click)="close()"
                            (keypress.enter)="close()">
                        </h-close-button>
                    </div>
                    <section class="notification-list">
                        <ul aria-labelledby="notification-title" i18n-aria-labelledby>
                            @for (notification of notificationsBanners; track notification) {
                                <h-notification-message [notificationMessage]="notification.content">
                                </h-notification-message>
                            }
                        </ul>
                    </section>
                </div>
            </ng-template>
        }
    }
}
